import { FloorPlan } from "~/_legacy/types/analysis";
import { FloorPlanResponse } from "~/_legacy/types/api";
import { convertFloorPlanResponseToFloorPlan } from "~/_legacy/utils/convert";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string) => `branches/${branchUid}/floor-plans/`;

export const fetchFloorPlans = async ({
  branchUid,
  branchVersionId,
}: {
  branchUid: string;
  branchVersionId?: number;
}) => {
  const url = createApiUrl(branchUid);
  const { data } = await axiosInstance.get<FloorPlanResponse[]>(url, {
    params: {
      version: branchVersionId,
    },
  });

  const converted: FloorPlan[] = data.map(convertFloorPlanResponseToFloorPlan);

  return converted;
};
